import { render, staticRenderFns } from "./ManagedAccountConfirmPortfolio.vue?vue&type=template&id=52ff6f14"
import script from "./ManagedAccountConfirmPortfolio.vue?vue&type=script&lang=ts"
export * from "./ManagedAccountConfirmPortfolio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports